import React from 'react';
import styled from '@emotion/styled';
import { h2Style } from './styles';

const H2Styled = styled.h2`
  ${h2Style};
`;

export default function H2(props: React.HTMLAttributes<HTMLHeadingElement>) {
  return <H2Styled {...props} />;
}
